export default "__VITE_ASSET__VxsgvaWi__"